import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import VehicleCard from "@/components/VehicleCard";
import FinanceLegalNote from "@/components/FinanceLegalNote";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { Skeleton } from "@/components/ui/skeleton";
import useSeo from "@/hooks/useSeo";

export default function VehiclesPage() {
  const { t } = useLang();
  const [vehicles, setVehicles] = useState(null);
  useSeo({
    title: "Fahrzeuge · Premium Gebrauchtwagen & Sportwagen Köln | DNA Automotive",
    description: "Exklusive Premium- und Sportfahrzeuge in Köln: Porsche, Mercedes-AMG, BMW M, Audi, Ferrari. Alle Modelle mit Finanzierung ab 4,9 % über Santander. In der MotorWorld Köln-Rheinland.",
    path: "/fahrzeuge",
    breadcrumbs: [{ name: "Fahrzeuge", url: "/fahrzeuge" }],
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get("/vehicles").then(({ data }) => setVehicles(data)).catch(() => setVehicles([]));
  }, []);

  return (
    <div className="bg-obsidian min-h-screen" data-testid="vehicles-page">
      <Header />
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 pt-36 pb-24">
        <p className="text-brand-bright text-xs uppercase tracking-[0.3em] mb-4">{t.fuhrpark.overline}</p>
        <h1 className="font-heading font-black uppercase tracking-tighter text-white text-5xl md:text-7xl mb-14">{t.fuhrpark.title}</h1>

        {vehicles === null ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[...Array(6)].map((_, i) => <Skeleton key={i} className="h-[360px] w-full bg-white/5" />)}
          </div>
        ) : vehicles.length === 0 ? (
          <p className="text-zinc-400 text-lg py-20 text-center border border-white/10">{t.fuhrpark.empty}</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {vehicles.map((v) => <VehicleCard key={v.id} vehicle={v} />)}
          </div>
        )}

        {vehicles && vehicles.length > 0 && <FinanceLegalNote className="mt-10 max-w-4xl" />}
      </div>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
